import React from "react";

const StepProgress = ({ steps, currentStep }) => {
  return (
    <div className="rounded-2xl bg-white p-4 shadow-md">
      <div className="flex items-center justify-between gap-2">
        {steps.map((label, index) => {
          const stepNumber = index + 1;
          const isDone = stepNumber < currentStep;
          const isActive = stepNumber === currentStep;
          return (
            <div key={label} className="flex flex-1 items-center gap-2">
              <div
                className={`flex h-8 w-8 items-center justify-center rounded-full border text-sm font-semibold ${
                  isDone || isActive
                    ? "border-maroon bg-maroon text-white"
                    : "border-gray-300 text-gray-400"
                }`}
              >
                {stepNumber}
              </div>
              <div className="hidden sm:block text-sm text-gray-600">{label}</div>
              {index < steps.length - 1 ? (
                <div
                  className={`h-[2px] flex-1 ${
                    stepNumber < currentStep ? "bg-maroon" : "bg-gray-200"
                  }`}
                />
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepProgress;
